// MEALUP effects on every page (2026-10-24; styles in assets/mu-fx.css). No new elements: only motion, depth and texture on what is there.
// Everything stays off for visitors who turn off motion, and nothing changes the layout (no shifts).
// 1. reveal: groups fade up with a stagger as they enter the screen (food equivalents, gifts, delivery track,
//    numbers, recipes, comparison ticks, step numbers, trust badges, section headings). Individual translate/scale
//    properties are used so the existing transforms (hover lifts) keep working.
// 2. count-up: the numbers in "Това е храна" count from 0
// 3. tilt: food photos and recipe photos lean towards the pointer (desktop with a mouse only)
// 4. grain: a fine film grain on the dark sections (marked here, drawn in mu-pdp.css)
// Endless CSS animations (announcement and badge marquees, ribbon drift, the button light, swipe arrows) pause while
// they are off screen: nobody sees them there, and each running one makes the browser restyle the page on every frame
// (on the product page that was about 15% of a laptop's main thread with nothing on screen moving). Paused with CSS
// (data-mu-off in mu-fx.css), so hover pauses and pause buttons keep working, and only the animated element and its
// ::before/::after: finite animations (reveals, the flavor timer bar) are never touched.
(function () {
  if (!('IntersectionObserver' in window) || !document.getAnimations) return;
  const watched = new WeakSet();
  const io = new IntersectionObserver((es) => es.forEach((e) => e.target.toggleAttribute('data-mu-off', !e.isIntersecting)), { rootMargin: '200px 0px' });
  const scan = () => document.getAnimations().forEach((a) => {
    const t = a.effect && a.effect.target;
    if (!t || watched.has(t) || a.effect.getTiming().iterations !== Infinity) return;
    watched.add(t);
    io.observe(t);
  });
  const later = () => { scan(); setTimeout(scan, 3000); };
  if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
  document.addEventListener('shopify:section:load', scan);
})();

(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  const root = document.documentElement;
  root.classList.add('mu-fx');

  const groups = [
    ['.mu-feq__list', ':scope > li'],
    ['.mu-sg__cards', ':scope > li'],
    ['.mu-sg__track', ':scope > li'],
    ['[class^="ai-mealup-numbers-stats-"]', ':scope > *'],
    ['.mu-hrec__strip', ':scope > li'],
    ['[class^="ai-step-process-cards-"]', '[class^="ai-step-card-number-"]'],
    ['[class^="ai-comparison-table__grid-"]', '[class*="ai-comparison-table__icon-"]'],
    ['.mu-pdp-badges__list', ':scope > li'],
    // home, recipes, story, encyclopedia, B2B, contact, collections
    ['.mu-hhow__steps', ':scope > li'],
    ['.mu-hflav__grid', ':scope > li'],
    ['.mu-goals__list', ':scope > li'],
    ['.mu-hcmp__table tbody', ':scope > tr'],
    ['.mu-rh__grid', ':scope > li'],
    ['.mu-tl__list', ':scope > li'],
    ['.mu-fc__grid', ':scope > li'],
    ['.mu-sp__list', ':scope > li'],
    ['.mu-ency-cards', ':scope > li'],
    ['.mu-steps', ':scope > li'],
    ['.mu-uc__grid', ':scope > li'],
    ['.mu-contact__list', ':scope > li'],
    ['.mu-rec ol', ':scope > li'],
    ['#ProductGridContainer .grid', ':scope > li'],
  ];
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      e.target.classList.add('mu-fx-in');
      io.unobserve(e.target);
      if (e.target.classList.contains('mu-fx-item')) return;
      if (e.target.matches('[class^="ai-mealup-numbers-stats-"]')) countUp(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });

  function arm() {
    groups.forEach(([g, child]) => {
      document.querySelectorAll(g).forEach((box) => {
        if (box.dataset.muFx) return;
        box.dataset.muFx = '1';
        box.classList.add('mu-fx-group');
        const items = box.querySelectorAll(child);
        // long vertical lists (recipes, articles) reveal item by item as they scroll in; short ones and sideways rows as one staggered group
        const each = items.length > 8 && !/(auto|scroll)/.test(getComputedStyle(box).overflowX);
        items.forEach((el, i) => { el.classList.add('mu-fx-item'); el.style.setProperty('--mu-i', each ? i % 3 : Math.min(i, 12)); if (each) io.observe(el); });
        if (!each) io.observe(box);
      });
    });
    // section headings (not in the first section of the page, the buy box or the science chapters, which animate themselves)
    const first = document.querySelector('main .shopify-section');
    document.querySelectorAll('main .shopify-section:not([id$="__main"]) h2').forEach((h) => {
      if (h.dataset.muFx || h.closest('.mu-fx-group') || h.closest('.shopify-section') === first || h.closest('[class*="mu-sci"]')) return;
      h.dataset.muFx = '1';
      h.classList.add('mu-fx-head');
      io.observe(h);
    });
    // the 30-day seal wobbles once when it comes into view
    document.querySelectorAll('.mu-pdp-guarantee__badge').forEach((b) => { if (!b.dataset.muFx) { b.dataset.muFx = '1'; b.classList.add('mu-fx-seal'); io.observe(b); } });
    // the main buttons get the light sweep
    document.querySelectorAll('.product__info-container .product-form__submit, main .mu-btn--primary, main .mu-btn:not(.mu-btn--outline)').forEach((b) => {
      b.classList.add('mu-fx-shine');
      if (b.dataset.muShine) return;
      b.dataset.muShine = '1';
      shineSeen.observe(b);
      setTimeout(() => sweep(b), 6220);
    });
    // film grain on the dark sections
    [document.querySelector('[class^="ai-mealup-numbers-"]'), document.querySelector('[class^="ai-ingredients-section-"]'), document.querySelector('.mu-pdp-badges')]
      .forEach((el) => { if (el) el.classList.add('mu-fx-grain'); });
  }

  // the light sweep: a short animation every 6.5 s instead of an endless one that mostly stands still (an endless
  // background animation restyles the button on every frame); skipped while the button is off screen or hidden
  const shineSeen = new IntersectionObserver((es) => es.forEach((e) => { e.target.muShineOn = e.isIntersecting; }));
  function sweep(b) {
    if (!b.isConnected) return;
    if (b.muShineOn && b.getClientRects().length) b.animate([{ backgroundPosition: '100% 0' }, { backgroundPosition: '0% 0' }], { duration: 2080, easing: 'ease-in-out' });
    setTimeout(() => sweep(b), 6500);
  }

  function countUp(box) {
    box.querySelectorAll('[class^="ai-mealup-numbers-stat-number-"]').forEach((box2) => {
      // a number per flavor ([protein] in snippets/mu-fl): count up the one that shows
      const el = [...box2.querySelectorAll('[data-mu-pack]')].find((s) => getComputedStyle(s).display !== 'none') || box2;
      const txt = el.textContent.trim();
      const m = txt.match(/^(\D*)(\d+)(.*)$/);
      if (!m) return;
      const end = parseInt(m[2], 10);
      if (!end) return;
      const start = performance.now(), dur = 1100;
      el.style.minWidth = el.offsetWidth + 'px';
      const step = (t) => {
        const p = Math.min(1, (t - start) / dur), v = Math.round(end * (1 - Math.pow(1 - p, 3)));
        el.textContent = m[1] + v + m[3];
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    });
  }

  // 3D lean towards the pointer, desktop only
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    const tiltSel = '.mu-feq__item, .mu-hrec__photo, .mu-rh-card__media, .mu-hflav__grid > li, .mu-ency-cards > li';
    document.addEventListener('pointermove', (e) => {
      const el = e.target.closest && e.target.closest(tiltSel);
      if (!el) return;
      const r = el.getBoundingClientRect();
      el.style.setProperty('--mu-rx', (((e.clientY - r.top) / r.height) - 0.5) * -7 + 'deg');
      el.style.setProperty('--mu-ry', (((e.clientX - r.left) / r.width) - 0.5) * 9 + 'deg');
      el.classList.add('mu-fx-tilting');
    }, { passive: true });
    document.addEventListener('pointerout', (e) => {
      const el = e.target.closest && e.target.closest(tiltSel);
      if (el && !el.contains(e.relatedTarget)) { el.classList.remove('mu-fx-tilting'); el.style.removeProperty('--mu-rx'); el.style.removeProperty('--mu-ry'); }
    }, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();
  window.addEventListener('load', arm);
  setTimeout(arm, 2500);
})();
